import { useSeo } from "@/hooks/useSeo";
import PageHeader from "@/components/PageHeader";
import AboutStory from "@/components/sections/AboutStory";
import FoundersSection from "@/components/sections/FoundersSection";
import WhyHashtag from "@/components/sections/WhyHashtag";
import CTASection from "@/components/sections/CTASection";
import { foundersSchema } from "@/data/seo";

const ABOUT_CRUMBS = [{ name: "About", path: "/about" }];
const ABOUT_SCHEMA = [foundersSchema()];

export default function About() {
  useSeo({
    title: "About Us: Founder-Led Integrated Marketing Agency Since 2013",
    description:
      "Independent, founder-led integrated marketing agency in Gurgaon, Delhi NCR, founded in 2013 by Gulnar Virk and Yuvraj Singh Virk. 15+ years of brand building.",
    path: "/about",
    pageType: "AboutPage",
    breadcrumbs: ABOUT_CRUMBS,
    schema: ABOUT_SCHEMA,
  });
  return (
    <>
      <PageHeader
        eyebrow="About"
        titleLines={["An independent", "agency with", "one story."]}
      />
      <AboutStory />
      <FoundersSection />
      <WhyHashtag />
      <CTASection />
    </>
  );
}
